module.exports = __webpack_public_path__ + "img/22.f214f5b7.jpg";